import { ComponentType } from './types';
import GraphNode, { StgyGraphAppend, StgyGraphInsert, StgyGraphShrink } from '../Node';
// 交易字段
export const TRADIND_KEYS = ['buy', 'sell'];
// 条件节点头部高度
export const CONDITION_HEAD_NODE_HEIGHT = 32;
// 图标的尺寸
export const ICON_SIZE = 20;
// 连线结束点至拐点的距离
export const END_DISTANCE = 52;
// 合并节点偏移量
export const MERGE_NODE_DISTANCE = 20;
// 节点x轴之间的间距
export const NODE_DISTANCE_X = 140;
// 节点y轴之间的间距
export const NODE_DISTANCE_Y = 120; // 原定为52 待优化
// 拖拽占位的间距
export const Y_DRAG_GAP = 3; // 原定为12 待优化
// 拖拽占位节点高度
export const DRAG_NODE_HEIGHT = 16;
// 节点默认宽度
export const NODE_W = 240;
// 节点默认高度
export const NODE_H = 68;
// 节点最大高度
export const NODE_MAX_H = 106;
// 迷你开始节点宽度
export const MINI_START_NODE_W = 52;
// 迷你开始节点宽度
export const MINI_START_NODE_H = 32;
// 组件对象映射
export const COMPONENTS = {
    [ComponentType.GRAPH_NODE]: GraphNode,
    [ComponentType.APPEND]: StgyGraphAppend,
    [ComponentType.INSERT]: StgyGraphInsert,
    [ComponentType.SHRINK_EXPAND]: StgyGraphShrink,
};
// 【+】的偏移量 - 有连接时
export const INSERT_JOIN_X_GAP = 60;
// 【+】的偏移量 - 有连接时 合并节点
export const INSERT_JOIN_X_GAP_MERGE = 40;
// 【+】的偏移量 - 无连接时
export const APPEND_EMPTY_X_GAP = 40;
// 展开收起 偏移量 有连接时
export const SHRINK_OPEN_X_GAP = 25;
// 展开收起 偏移量 有连接时 合并节点
export const SHRINK_OPEN_X_GAP_MERGE = 5;
// 展开收起 偏移量
export const SHRINK_CLOSE_X_GAP = 40;
// 【添】偏移量
export const APPEND_X_GAP = 44;
